<template>
  <BookmarksList v-if="isBookmarksShown" :list="bookmarksList" />

  <MobileList
    v-else-if="isMobile"
    id="mobileTrainersList"
    :list="trainersList"
    :pages-number="pagesNumber"
    :is-empty="isTrainersListEmpty"
    @changePageMobile="toAnotherPage"
  />

  <DesktopList
    v-else-if="!isMobile && (trainersList.length || isTrainersListEmpty)"
    id="scrollableTrainersList"
    :list="trainersList"
    :page="currentPage"
    :pages-number="pagesNumber"
    @changePageDesktop="toAnotherPage"
    @anotherQuery="loadTrainersList"
  />

  <div v-else class="loading-wrapper">
    <vue-loaders name="ball-pulse" scale="1" color="#2f8e97" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BookmarksList from '@/components/Search/TrainersListTypes/BookmarksList'
import DesktopList from '@/components/Search/TrainersListTypes/DesktopList'
import MobileList from '@/components/Search/TrainersListTypes/MobileList'

export default {
  name: 'TrainersList',
  components: {
    BookmarksList,
    DesktopList,
    MobileList
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    ...mapGetters({
      trainersList: 'search/getTrainersList',
      isMobile: 'common/getWidth',
      pagesNumber: 'search/getPagesNumber',
      isBookmarksShown: 'search/isBookmarksShown',
      bookmarksList: 'search/getBookmarksList',
      currentPage: 'search/searchPage',
      searchLocation: 'search/searchLocation',
      isTrainersListEmpty: 'search/getTrainersListFilling',
      cachedTrainers: 'search/getCachedTrainers'
    })
  },
  watch: {
    isMobile: {
      immediate: true,
      async handler(val) {
        if (!val) {
          this.list = []
          if (!this.cachedTrainers) {
            //  if there are cached trainers don`t change page
            //  (necessary page number is already in the store)
            await this.setCurrentPage(this.currentPage)
          }
        }
      }
    },
    async searchLocation(val, old) {
      if (val && old) {
        if (this.isMobile) {
          this.$bus.$emit('clearList')
        }
        //  load trainers list if location changed
        await this.loadTrainersList()
      }
    }
  },
  methods: {
    ...mapActions({
      loadTrainersList: 'search/LOAD_TRAINERS_LIST',
      setCurrentPage: 'search/SET_CURRENT_PAGE',
      cacheTrainers: 'search/CACHE_TRAINERS'
    }),
    async toAnotherPage(newPage) {
      await this.setCurrentPage(newPage)
      await this.loadTrainersList(this.isMobile ? null : newPage)
    }
  }
}
</script>

<style scoped lang="scss">
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
